import React, {useEffect, useState, useContext} from 'react'
import axios from 'axios'
import { GlobalState } from '../../GlobalState';
import bg from '../../img/bg.png'

export default function DeleteData() {
    const state = useContext(GlobalState)
    const [token] = state.token

    const [dataFile, setDataFile] = useState('')
    const [fileName, setFileName] = useState('')
    const [sheetNumber, setSheetnmber] = useState(null)

    const handleFile = (e)=>{
        const file = e.target.files[0];
        if (file) {
            // Chuyển đổi tệp thành BLOB
            const reader = new FileReader();
            reader.onload = (event) => {
                const blob = new Blob([event.target.result], { type: file.type });
                setDataFile(blob);
                setFileName(file.name)
            };
            reader.readAsArrayBuffer(file);
        }
    }

    const handleSubmit = async ()=>{
        if(!dataFile){
            alert('Vui lòng chọn file.')
        }
        else if(!sheetNumber){
            alert('Vui lòng nhập thứ tự sheet.')
        }
        else {
            try {
                const formData = new FormData();
                formData.append('file', dataFile, `${fileName}`);
    
                const res = await axios.post(`/api/delete_infor?sheet=${sheetNumber}`, formData, {
                    headers: {
                        // 'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                alert(res.data.msg)
                // console.log(formData)
                
            } catch (err) {
                alert(err.response.data.msg)
            }
        }
    }

    // console.log(dataFile)

  return (
    <div className='w-full text-center mr-[40px] border-[3px] border-[#880000] p-[10px] bg-white'>
        <p className='font-bold mb-[20px] text-[#880000]'>Xóa dữ liệu</p>
        <input type="file" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFile} onClick={e => (e.target.value = null)}
            className='h-[40px] mb-[20px]' />
        <br/>

        <input type="number" value={sheetNumber} onChange={(e)=>setSheetnmber(e.target.value)} placeholder='Nhập thứ tự sheet....'
            className='w-[300px] h-[40px] border-[1px] border-[#bbb] text-center rounded-sm shadow-md' />
        <br/>
        <button className='bg-[#880000] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#5bdb31] shadow-md'
            onClick={handleSubmit}>Xóa</button>
    </div>
  )
}
